import httpClient from "./httpClient";

const base = "/student-reports";

export function listStudentsByClass(classId, academicYear) {
  return httpClient.get(`${base}/by-class`, { params: { classId, academicYear } }).then((res) => res.data.data);
}

export function listStudentsByGroup(classConfigurationId, groupId, academicYear) {
  return httpClient
    .get(`${base}/by-group`, { params: { classConfigurationId, groupId, academicYear } })
    .then((res) => res.data.data);
}

export function listStudentsByAdmissionDate(classConfigurationId, academicYear, fromDate, toDate) {
  const params = { academicYear, fromDate, toDate };
  if (classConfigurationId) {
    params.classConfigurationId = classConfigurationId;
  }
  return httpClient.get(`${base}/by-admission-date`, { params }).then((res) => res.data.data);
}

export function singleSearchStudent(customStudentId) {
  return httpClient.get(`${base}/single-search`, { params: { customStudentId } }).then((res) => res.data.data);
}

export function getSectionWiseSummary(academicYear) {
  return httpClient.get(`${base}/section-wise-summary`, { params: { academicYear } }).then((res) => res.data.data);
}

export function getGenderReligionSummary(classIds, academicYear) {
  // Repeated-key query string (classId=1&classId=2), not axios's default
  // classId[]=... bracket form — see dashboardApi.js's getTotalStudent for
  // why (Tomcat rejects literal unencoded brackets before CORS even runs).
  const query = new URLSearchParams();
  (classIds || []).forEach((id) => query.append("classId", id));
  query.append("academicYear", academicYear);
  return httpClient.get(`${base}/gender-religion-summary?${query.toString()}`).then((res) => res.data.data);
}
